import { ActivityFeed } from "../../components/ActivityFeed";

/**
 * ABONELİK/KULLANIM/EK HAK/FATURALAMA AKTİVİTE GEÇMİŞİ (CLOS-286 `[181]`, alt görev
 * CLOS-975).
 *
 * ### ⚠ Ayrı bir sidebar sayfası DEĞİL
 *
 * Kart: *"Aktivite ayrı sidebar sayfası değildir; D06 Abonelik ve Kullanım ... bağlamında
 * gösterilir."* Bu yüzden `SubscriptionOverviewPage`'in İÇİNE gömülüyor, kendi rotası yok.
 *
 * ### ⚠ Finansal maskeleme SUNUCUDA — burada ikinci bir karar YOK
 *
 * `ActivityFeed` zaten satırı olduğu gibi gösteriyor; `masked` alanı doluysa aktör ve
 * özet parametreleri sunucu tarafından boşaltılmış geliyor (`lib/activity/access.ts`).
 * İstemci "fiyatı gizle" gibi bir karar VERMİYOR — vermesi, sunucunun maskelediği bir
 * alanı istemcinin bir gün yanlışlıkla göstermesi demek olurdu.
 */
export function SubscriptionActivitySection({ subscriptionId }: { subscriptionId: string }) {
  return (
    <ActivityFeed
      entityType="subscription"
      entityId={subscriptionId}
      title="Abonelik faaliyet geçmişi"
    />
  );
}
